import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private apiUrl = environment.apiBaseUrl +'/api/dashboard';

  constructor(private http: HttpClient) { }

  getDashboardStats(role: string | null): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}?role=${role}`);
  }
}

